export default "__VITE_ASSET__DY_5gzi0__"